import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../../components/header_logged'
import Footer from '../../../../components/footer'
import Head from '../../../../components/head';
import ProfsSaudeLogged from '../../../../components/auth/saude/profissionais'

function ProfsSaudeLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Módulo de Profissionais da Secretaria Municipal de Saúde" />
                <HeaderLogged />
                <Container>
                   <ProfsSaudeLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default ProfsSaudeLoggedScreen;